import axios from 'axios';
import qs from 'qs';

import EventBus from '@/event-bus';
import Logger from '@/Logger';

// Create instance of logger
const logger = new Logger('authStore', 'Actions');

export default {
  authLogin({ commit, dispatch }, user) {
    return new Promise(async (resolve, reject) => {
      try {
        // Return promise values back to component
        const response = await axios.post('login', qs.stringify({
          email: user.email, password: user.password,
        }));
        // Succeeded -> mutate state
        commit('authSuccess');

        // Log action and status.
        logger.info('authLogin', 'Response', response.data);

        // Commit user object from response.
        await dispatch('getMe');

        // Dispatch getNavigation
        await dispatch('getNavigation');

        resolve();
      } catch (error) {
        // Log action and status.
        console.warn(error);
        reject();
      }
    });
  },
  authLogout({ commit, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post('logout');

        // Log action and status.
        logger.info('authLogout', 'Response', response.data);

        // Set isAuthenticated state to false
        commit('authLogout');

        // Finally, clear user data
        dispatch('clearMe');

        // Remove stored filters
        dispatch('clearFilters');

        // Clean up all root event listeners on log out.
        EventBus.$off();

        resolve();
      } catch (error) {
        // Log action and status.
        console.warn(error);
        reject();
      }
    });
  },
};
